/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="12.87"
        height="12.87"
        viewBox="0 0 12.87 12.87"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m1.2.14.08.08 5.16 5.15L11.59.22a.754.754 0 0 1 1.13 1l-.07.09L7.5 6.46l5.15 5.15a.758.758 0 0 1-1 1.14l-.09-.08-5.15-5.15-5.16 5.15a.74.74 0 0 1-1.06 0 .75.75 0 0 1-.07-1l.07-.09 5.16-5.15L.19 1.28a.758.758 0 0 1 1-1.14Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'CloseIcon';

export default Icon;
